import {
  DEFAULT_HUBUP_NOTIFICATION_BUTTON_COLOR,
  DEFAULT_HUBUP_NOTIFICATION_BUTTON_LABEL,
  normalizeHubupNotificationButtonColor,
} from './campaignEmailTemplate';

export const EMAIL_BANNER_SIZE_TOOLTIP =
  'Bandeau en tête du mail : 600 × 200 px recommandé (largeur × hauteur). JPG, PNG, GIF ou WebP — 5 Mo max.';

export const BUTTON_SHAPES = [
  { id: 'pill', label: 'Pill (arrondi max)' },
  { id: 'rounded', label: 'Arrondi' },
  { id: 'square', label: 'Carré' },
];

export function buttonBorderRadiusPx(shape) {
  const s = String(shape || 'rounded').trim();
  if (s === 'pill') return '9999px';
  if (s === 'square') return '4px';
  return '12px';
}

function readableTextOnBg(hexBg) {
  const hex = normalizeHubupNotificationButtonColor(hexBg).replace('#', '');
  const r = Number.parseInt(hex.slice(0, 2), 16);
  const g = Number.parseInt(hex.slice(2, 4), 16);
  const b = Number.parseInt(hex.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#111827' : '#ffffff';
}

export function defaultHubupButtonDesign() {
  return {
    buttonLabel: DEFAULT_HUBUP_NOTIFICATION_BUTTON_LABEL,
    buttonColor: DEFAULT_HUBUP_NOTIFICATION_BUTTON_COLOR,
    buttonBorderColor: DEFAULT_HUBUP_NOTIFICATION_BUTTON_COLOR,
    buttonTextColor: '',
    buttonShape: 'rounded',
  };
}

export function defaultProductPaymentButtonDesign() {
  return {
    paymentButtonLabel: 'Payer ma commande',
    paymentButtonBackgroundColor: '#111827',
    paymentButtonBorderColor: '#111827',
    paymentButtonTextColor: '#ffffff',
    paymentButtonShape: 'rounded',
  };
}

export function defaultProductCardOptions() {
  return {
    includeProductCard: false,
    showImage: true,
    showDescription: true,
    ...defaultProductPaymentButtonDesign(),
  };
}

/** Lit le design HubUP depuis un template, avec repli sur la campagne. */
export function hubupButtonDesignFromSource(source, fallbackSource) {
  const d = defaultHubupButtonDesign();
  const primary = source || {};
  const fallback = fallbackSource || {};
  const pick = (field, key) => {
    const p = primary[key];
    if (p !== undefined && p !== null && String(p).trim() !== '') return p;
    const f = fallback[key];
    if (f !== undefined && f !== null && String(f).trim() !== '') return f;
    return d[field];
  };
  const color = pick('buttonColor', 'hubupEmailNotificationButtonColor');
  return {
    buttonLabel: pick('buttonLabel', 'hubupEmailNotificationButtonLabel'),
    buttonColor: color,
    buttonBorderColor:
      pick('buttonBorderColor', 'hubupEmailNotificationButtonBorderColor') || color,
    buttonTextColor: pick('buttonTextColor', 'hubupEmailNotificationButtonTextColor') || '',
    buttonShape: pick('buttonShape', 'hubupEmailNotificationButtonShape'),
  };
}

export function productCardOptionsFromSource(source) {
  const d = defaultProductCardOptions();
  if (!source) return d;
  return {
    includeProductCard:
      source.emailIncludeProductCard !== undefined
        ? Boolean(source.emailIncludeProductCard)
        : d.includeProductCard,
    showImage:
      source.emailProductCardShowImage !== undefined
        ? Boolean(source.emailProductCardShowImage)
        : d.showImage,
    showDescription:
      source.emailProductCardShowDescription !== undefined
        ? Boolean(source.emailProductCardShowDescription)
        : d.showDescription,
    paymentButtonLabel:
      source.emailProductCardPaymentButtonLabel || d.paymentButtonLabel,
    paymentButtonBackgroundColor:
      source.emailProductCardPaymentButtonBackgroundColor ||
      d.paymentButtonBackgroundColor,
    paymentButtonBorderColor:
      source.emailProductCardPaymentButtonBorderColor ||
      d.paymentButtonBorderColor,
    paymentButtonTextColor:
      source.emailProductCardPaymentButtonTextColor || d.paymentButtonTextColor,
    paymentButtonShape:
      source.emailProductCardPaymentButtonShape || d.paymentButtonShape,
  };
}

export function hubupButtonDesignToEmailFields(design) {
  const d = { ...defaultHubupButtonDesign(), ...design };
  return {
    hubupEmailNotificationButtonLabel: d.buttonLabel,
    hubupEmailNotificationButtonColor: d.buttonColor,
    hubupEmailNotificationButtonBorderColor: d.buttonBorderColor,
    hubupEmailNotificationButtonTextColor: d.buttonTextColor || null,
    hubupEmailNotificationButtonShape: d.buttonShape,
  };
}

export function productCardOptionsToEmailFields(options) {
  const o = { ...defaultProductCardOptions(), ...options };
  return {
    emailIncludeProductCard: Boolean(o.includeProductCard),
    emailProductCardShowImage: o.showImage,
    emailProductCardShowDescription: o.showDescription,
    emailProductCardPaymentButtonLabel: o.paymentButtonLabel,
    emailProductCardPaymentButtonBackgroundColor: o.paymentButtonBackgroundColor,
    emailProductCardPaymentButtonBorderColor: o.paymentButtonBorderColor,
    emailProductCardPaymentButtonTextColor: o.paymentButtonTextColor,
    emailProductCardPaymentButtonShape: o.paymentButtonShape,
  };
}

export function buildEmailAnchorInlineStyle({
  backgroundColor,
  borderColor,
  textColor,
  shape,
}) {
  const bg = normalizeHubupNotificationButtonColor(backgroundColor || '#111827');
  const border = normalizeHubupNotificationButtonColor(
    borderColor || backgroundColor || bg,
  );
  const color =
    String(textColor || '').trim() && /^#[0-9a-fA-F]{6}$/.test(textColor)
      ? textColor
      : readableTextOnBg(bg);
  return `display:inline-block;background-color:${bg};color:${color};border:2px solid ${border};border-radius:${buttonBorderRadiusPx(shape)};padding:12px 28px;font-size:15px;font-weight:700;line-height:1;text-decoration:none;`;
}
